import React from 'react'
import SbcCommon from '../../../toolkit/SbcCommon';
import SbcWrapper from '../../../toolkit/SbcWrapper';
import SbcOptions from '../../../toolkit/SbcOptions';

export default function CheckboxConfig({
    data,
    handleIptChange,
    handleMultiIptChange,
    handleSwitchChange,
    handleSelectChange,
    handleOptions,
    handleDragOptions
}) {
    return (
        <SbcWrapper>
            <SbcCommon
                data={data}
                handleIptChange={handleIptChange}
                handleMultiIptChange={handleMultiIptChange}
                handleSwitchChange={handleSwitchChange}
                handleSelectChange={handleSelectChange}
            />
            <SbcOptions
                data={data}
                handleIptChange={handleIptChange}
                handleMultiIptChange={handleMultiIptChange}
                handleSwitchChange={handleSwitchChange}
                handleSelectChange={handleSelectChange}
                handleOptions={handleOptions}
                handleDragOptions={handleDragOptions}
            />
        </SbcWrapper>
    )
}
